import { scorT, scorCount } from 'i18n/scorLocale';

export const SCOR_ISSUER_MAX_LENGTH = 255;

export const SCOR_COMMENT_MAX_LENGTH = 2000;

export interface ScorOrderValidationValues {
  categoryId: number;
  serviceId: number;
  issuer: string;
  comment: string;
  sum: string;
  consent: boolean;
  documentCount: number;
  documentsRequired?: boolean;
  categoryFields: ApiScorCategoryField[];
  fields: Record<string, string | number | boolean>;
}

export const validateScorOrder = (values: ScorOrderValidationValues): Record<string, string> => {
  const errors: Record<string, string> = {};
  if (!values.categoryId) errors.category_id = scorT('selectACategory');
  if (!values.serviceId) errors.service_id = scorT('selectAReportType');
  if (!values.issuer.trim()) errors.issuer = scorT('enterAProductNameOrIssuer');
  else if (values.issuer.length > SCOR_ISSUER_MAX_LENGTH) errors.issuer = scorT('noMoreThan255Characters');
  if (values.comment.length > SCOR_COMMENT_MAX_LENGTH) errors.comment = scorT('noMoreThan2000Characters');
  if (!values.consent) errors.consent = scorT('youMustAcceptTheDocuments');
  if (values.documentsRequired !== false && values.documentCount === 0) errors.documents = scorT('addAtLeastOneDocument');
  if (values.sum && (!Number.isFinite(Number(values.sum)) || Number(values.sum) < 0)) {
    errors.sum_deal_rub = scorT('enterAnAmountOf0OrMore');
  }

  values.categoryFields.forEach((field) => {
    if (!field.code) return;
    const value = values.fields[field.code];
    const key = `fields.${field.code}`;
    const empty = value === undefined || String(value).trim() === '';

    if (field.type === 'bool') {
      if (field.is_required && value !== true) errors[key] = scorT('confirmationRequired');
    } else if (empty) {
      if (field.is_required) errors[key] = scorT('completeThisRequiredField');
    } else if (field.type === 'select' && !(field.options ?? []).includes(String(value))) {
      errors[key] = scorT('selectAnAvailableOption');
    } else if ((field.type === 'number' || field.type === 'money') && !Number.isFinite(Number(value))) {
      errors[key] = scorT('enterANumber');
    }
  });

  return errors;
};

export const formatScorWorkingDays = (days: number): string => scorCount('workingDays', days);
